import createReactClass from 'create-react-class';
import React from 'react';

import {DataTable} from 'notebook/data-tables/DataTableConstants';
import DataTableEditable from 'notebook/data-tables/DataTableEditable';
import {convertDataTableToTable, mergeTableUpdateIntoDataTable} from 'notebook/data-tables/DataTableUtil';
import {EMPTY_SEARCH_RESULT_PROPS} from 'notebook/mediocre/search/SearchResultProps';
import {NoteEditor, NoteEditorProps} from 'notebook/notes/NoteEditorTypes';
// @ts-expect-error module still JS
import {SimpleSpreadsheetEvalMixin} from 'notebook/simple-tables/SimpleSpreadsheetEvalMixin';
import {CellColors, ColumnConstraint, Table, TableData} from 'notebook/tables/TableConstants';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {AssayResult} from 'results/assays/AssayRecordConstants';

import {fillEmptyDataTableWithResults} from './AssayGroupDataTables';

interface AssayGroupResultsTableProps {
  schema: AssaySchema;
  results: Array<AssayResult>;
  isOversized: boolean;
  forceRowCount?: number;
  dataTable: DataTable;
  downloadAsCSV: (schemaId?: string) => void;
  onDataTableUpdate: (dataTable: DataTable) => void;
  editor: NoteEditor;
  editorProps: NoteEditorProps;
}

interface AssayGroupResultsTableState {
  tableNamespace: string;
  showExcessLabels: boolean;
  cellColors?: CellColors;
}

// oxlint-disable-next-line react/prefer-es6-class
const AssayGroupResultsTable = createReactClass<AssayGroupResultsTableProps, AssayGroupResultsTableState>({
  mixins: [SimpleSpreadsheetEvalMixin],

  _getFilledDataTable(props: AssayGroupResultsTableProps): DataTable {
    return fillEmptyDataTableWithResults(props.dataTable, props.results, props.schema);
  },

  /* Required by SpreadsheetEvalMixin */
  spreadsheetRoot(props: AssayGroupResultsTableProps): DataTable {
    return this._getFilledDataTable(props);
  },

  /* Required by SpreadsheetEvalMixin */
  shouldDisableFormulas(): boolean {
    return true;
  },

  /* Required by SimpleSpreadsheetEvalMixin */
  handleTableUpdate(index: unknown, {table, selection}: {table: TableData; selection: unknown}) {
    // TODO(BNCH-2694): Call `this.props.editor.requestSelection(selection);` and thread metadataForRestore
    // to DataTablEditable for best editing experience.
    this._handleDataTableUpdate(index, {table});
  },

  /* Required by SimpleSpreadsheetEvalMixin */
  getTable(props: AssayGroupResultsTableProps): Table & {columnConstraints: Array<ColumnConstraint>} {
    return convertDataTableToTable(this._getFilledDataTable(props));
  },

  /* Required by SimpleSpreadsheetEvalMixin */
  getTableCid(): string {
    return this.props.dataTable.cid;
  },

  _handleDataTableUpdate(_index: unknown, {table, item}: {table: TableData; item: DataTable}) {
    const newDataTable = item || mergeTableUpdateIntoDataTable(this.props.dataTable, table);
    const newEmptyDataTable = {...newDataTable, rows: []};
    this.props.onDataTableUpdate(newEmptyDataTable);
  },

  render() {
    return (
      <DataTableEditable
        cid={this.getTableCid()}
        dataTable={this._getFilledDataTable(this.props)}
        downloadAsCSV={this.props.downloadAsCSV}
        editor={this.props.editor}
        editorProps={this.props.editorProps}
        editorOverrides={this.getTableEditableProps()}
        fileId={this.props.editorProps.fileId}
        registrationTables={[]}
        indentation={0}
        index={0}
        locked={this.props.editorProps.locked}
        updateHandler={this._handleDataTableUpdate}
        tableNamespace={this.state.tableNamespace}
        viewer={this.props.editorProps.viewer}
        computedTable={this.getComputedTable()}
        multiEditing={false}
        showExcessLabels={this.state.showExcessLabels}
        metadataForRestore={undefined}
        cellColors={this.state.cellColors}
        forRun={true}
        isOversized={this.props.isOversized}
        forceRowCount={this.props.forceRowCount}
        isMaximized={false}
        {...EMPTY_SEARCH_RESULT_PROPS}
      />
    );
  },
});

export default AssayGroupResultsTable;
